import _regeneratorRuntime from 'babel-runtime/regenerator';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import InlineSvg from './InlineSvg';
import { Input } from 'semantic-ui-react';

var ContextMenu = function (_React$Component) {
  _inherits(ContextMenu, _React$Component);

  function ContextMenu(props) {
    _classCallCheck(this, ContextMenu);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onContextClick = function () {
      _this.setState(_extends({}, _this.state, {
        menuOpen: !_this.state.menuOpen
      }));
    };

    _this.handleSearchInput = function (event) {
      // $FlowFixMe
      _this.setState({
        filterValue: event.target.value
      });
    };

    _this.state = {
      menuOpen: false,
      filterValue: ''
    };
    return _this;
  }

  ContextMenu.prototype.render = function render() {
    var _props = this.props,
        handleItemChange = _props.handleItemChange,
        contextType = _props.contextType,
        items = _props.items,
        currentItem = _props.currentItem;
    var _state = this.state,
        menuOpen = _state.menuOpen,
        filterValue = _state.filterValue;
    var contextTypeLabel = contextType ? contextType : '';
    var currentItemInt = parseInt(currentItem);
    var setItem = items.find(function (item) {
      return item.id === currentItemInt;
    });
    var currentFilter = filterValue || ''; // TODO: Fix this
    // eslint-disable-next-line

    var ContextItems = items.map(function (item) {
      var _this2 = this;

      var itemName = item.name.toLowerCase();
      var filter = currentFilter.toLowerCase();

      if (itemName === filter || itemName.includes(filter) || filter === '') {
        // TODO: Fix this

        /* eslint-disable */
        return React.createElement('li', {
          key: item.id,
          id: item.id,
          onClick: _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return handleItemChange(item.id);

                  case 2:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this2);
          }))
        }, item.name);
      }
      /* eslint-enable */

    }); // TODO: Fix this

    /* eslint-disable */

    return React.createElement('div', {
      className: 'context-menu ' + (menuOpen ? 'context-menu--open' : '')
    }, React.createElement('button', {
      className: 'context-menu__item',
      onClick: this.onContextClick
    }, React.createElement('div', {
      className: 'context-menu__item-text'
    }, React.createElement('div', {
      className: 'context-menu__context-text'
    }, contextTypeLabel), React.createElement('div', {
      className: 'context-menu__selected-text'
    }, setItem ? setItem.name : '')), React.createElement('div', {
      className: 'context-menu__item-icon'
    }, React.createElement(InlineSvg, {
      name: 'dropDownArrow',
      className: 'context-dropdown-arrow ' + (menuOpen ? 'context-dropdown-arrow--open' : '')
    }))), React.createElement('div', {
      className: 'context-menu__dropdown ' + (menuOpen ? 'context-menu__dropdown--open' : '')
    }, React.createElement('div', {
      className: 'context-menu__search-container'
    }, React.createElement(Input, {
      className: 'context-menu__search',
      iconPosition: 'left',
      placeholder: 'Filter ' + contextTypeLabel + '...',
      onChange: this.handleSearchInput,
      icon: 'search'
    })), React.createElement('ul', {
      className: 'context-menu__list'
    }, ContextItems, _typeof(ContextItems[0]) === undefined && React.createElement('li', null, React.createElement('em', null, 'No results')))));
  };

  return ContextMenu;
}(React.Component);

export default ContextMenu;